import { render, staticRenderFns } from "./FormLanguage.vue?vue&type=template&id=bd929708&"
import script from "./FormLanguage.vue?vue&type=script&lang=js&"
export * from "./FormLanguage.vue?vue&type=script&lang=js&"
import style0 from "./FormLanguage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports